import styled from "styled-components";

export const GeneralAvailabilityMyCoach = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.secondaryGrayLightFour};
`;

export const ContainerBack = styled.div`
  display: grid;
  grid-template-columns: 6vw 17vw 1fr;
  align-items: center;
`;

export const ContentBack = styled.div`
  display: grid;
  grid-template-columns: 5.5vw 7vw;
  width: 100%;
`;

export const ButtonBack = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 70%;
  height: 25px;
  margin: 0px auto;
  text-align: left;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const HR = styled.hr`
  background-color: ${({ theme }) => theme.secondaryGrayLightThree};
  height: 1px;
  width: 96.5%;
`;
